import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { KeyValuePair } from 'helpers';

interface IApplicationContext {
    isLoading: boolean
    referenceData: IReferenceData,
}

interface IReferenceData {
    markets: KeyValuePair<string, string>[]
    brands: KeyValuePair<string, string>[]
    programs: KeyValuePair<string, string>[]
    countries: KeyValuePair<string, string>[]
    availableCountries: KeyValuePair<string, string>[]
}

export let applicationContext = React.createContext({} as IApplicationContext);

let { Provider } = applicationContext;

let ApplicationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [referenceData, setReferenceData] = useState({} as IReferenceData);


    useEffect(() => {
        getReferenceData();
    }, [])


    let getReferenceData = async () => {
        try {
            setLoading(true);
            let res = await axios.get('/api/ReferenceData/GetReferenceData');

            let { item } = res.data;
            setReferenceData(item);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                referenceData
            }}
        >
            {children}
        </Provider>
    )
}

export default ApplicationProvider;